import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when the route or query parameters change
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);

  return null;
};

export default ScrollToTop;
